import { useSsrAdapter as a } from "../../../../../@css-render_vue3-ssr@0.15.14_vue@3.5.18/node_modules/@css-render/vue3-ssr/esm/index.js";
import "../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import d from "../_styles/global/index.cssr.js";
import { configProviderInjectionKey as f } from "../config-provider/src/context.js";
import { cssrAnchorMetaName as s } from "./common.js";
import { throwError as u } from "../_utils/naive/warn.js";
import { inject as m, onBeforeMount as p } from "../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function S(t, i, l) {
  if (!i) {
    process.env.NODE_ENV !== "production" && u("use-style", "No style is specified.");
    return;
  }
  const r = a(), e = m(f, null), n = () => {
    const o = l.value;
    i.mount({
      id: o === void 0 ? t : o + t,
      head: !0,
      anchorMetaName: s,
      props: {
        bPrefix: o ? `.${o}-` : void 0
      },
      ssr: r,
      parent: e == null ? void 0 : e.styleMountTarget
    }), e != null && e.preflightStyleDisabled || d.mount({
      id: "n-global",
      head: !0,
      anchorMetaName: s,
      ssr: r,
      parent: e == null ? void 0 : e.styleMountTarget
    });
  };
  r ? n() : p(n);
}
export {
  S as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_mixins/use-style.js
// module id = 148
// module chunks = 67